import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { fetchModuleGroup } from '../store/slices/modulegroupSlice';
import './CategoryMaster.css';

const ModuleGroupHeader = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchModuleGroup());
    }, [dispatch]);

    return (
        <div className="mb-4">
            <h2 className="text-3xl font-bold mb-2" style={{ color: 'var(--primary-color)' }}>
                Module Groups
            </h2>
            <p className="text-color-secondary">View and manage module group records</p>
        </div>
    );
};

export default ModuleGroupHeader;
